export const firstCharUpperCase = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Capitalizes the first letter of each word in a name.
 * e.g., "john doe" -> "John Doe", "JANE SMITH" -> "Jane Smith"
 */
export const capitalizeName = (name: string): string => {
  if (!name) return name;
  return name
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
